import React, { useState } from "react";
import { Button, Modal, Form, InputGroup } from "react-bootstrap";
// import { FiLink } from "react-icons/fi";
// import { FaFacebookF, FaWhatsapp } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
// import { MdEmail } from "react-icons/md";

/**
 * Share modal styled like the provided reference.
 * Replace icons/variants as needed to match theme.
 */
const ShareModal = ({ show, onHide, link, title = "Share this event" }) => {
  const shareLink =
    link || (typeof window !== "undefined" ? window.location.href : "");
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  const shareTargets = [
    // {
    //   label: "Share on Facebook",
    //   icon: <FaFacebookF size={18} />,
    //   href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    //     shareLink
    //   )}`,
    // },
    // {
    //   label: "Share on X (Twitter)",
    //   icon: <FaXTwitter size={18} />,
    //   href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    //     shareLink
    //   )}`,
    // },
    // {
    //   label: "Share on WhatsApp",
    //   icon: <FaWhatsapp size={18} />,
    //   href: `https://wa.me/?text=${encodeURIComponent(shareLink)}`,
    // },
    // {
    //   label: "Share via Email",
    //   icon: <MdEmail size={18} />,
    //   href: `mailto:?subject=Check%20this%20event&body=${encodeURIComponent(
    //     shareLink
    //   )}`,
    // },
  ];

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-3 p-4 my-2">
        {shareTargets.map((item) => {
          const commonProps = {
            key: item.label,
            className:
              "d-flex align-items-center gap-4 justify-content-start btn btn-light-lg",
            variant: "none",
            style: { textAlign: "left" },
          };

          if (item.as === "button") {
            return (
              <Button
                {...commonProps}
                as="a"
                href={item.href}
                target="_blank"
                rel="noreferrer"
              >
                <div className="icon-circle">{item.icon}</div>
                <span>{item.label}</span>
              </Button>
            );
          }

          return (
            <Button
              {...commonProps}
              as="a"
              href={item.href}
              target="_blank"
              rel="noreferrer"
            >
              {item.icon}
              <span>{item.label}</span>
            </Button>
          );
        })}

        <InputGroup className="mt-1">
          <Form.Control readOnly value={shareLink} />
          <Button variant="btn  btn-orange" onClick={handleCopy}>
            {copied ? "Copied" : "Copy"}
          </Button>
        </InputGroup>
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;
